import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { OrdinaryQuery } from 'private-angular-vhframeworks';

@Component({
  selector: 'app-software',
  templateUrl: './software.component.html',
  styleUrls: ['./software.component.scss']
})
export class SoftwareComponent implements OnInit {
  @Output() contactSoftStatus: EventEmitter<any> = new EventEmitter()
  software: any = [
    {
      path: '/software/cafe',
      img: "https://115.78.228.208:20350/bvhsales/lXjeqUwuBqScIkuf7sibcx2SF383//assets/home/cafe.jpeg",
      name: 'Phần mềm quản lý Cà phê, nhà hàng',
      describe: 'Phù hợp với nhiều mô hình nhà hàng, quán ăn, quản lý đặt bàn , đặt món, kiểm soát từ xa.'
    },
    {
      path: '/software/sale',
      img: "https://115.78.228.208:20350/bvhsales/lXjeqUwuBqScIkuf7sibcx2SF383//assets/home/solution3.jpeg",
      name: 'Phần mềm quản lý bán hàng',
      describe: 'Giúp các doanh nghiệp tối ưu hóa việc quản lý kinh doanh, quản lý kho hàng, hỗ trợ bán hàng nhanh chóng.'
    },
    {
      path: '/software/cloudcam',
      img: "https://115.78.228.208:20350/bvhsales/lXjeqUwuBqScIkuf7sibcx2SF383//assets/home/cloudcamera.jpeg",
      name: 'Phần mềm Cloud Camera',
      describe: 'Quản lý và giám sát mọi lúc, Cloud Camera được tích hợp công nghệ AI, lưu trữ dữ liệu trên đám mây và các thiết bị điều khiển giúp bạn an tâm hơn khi vắng nhà, công sở.'
    }];
  isMobile: any
  constructor(
    private router: Router,
    public platform: Platform
  ) {
    if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
  }
  ngOnInit(): void { }

  inHover(event, url: any) {
    event.target.style.backgroundImage = "linear-gradient(rgba(255,255,255,0.7),rgba(255,255,255,0.7)),url(" + url + ")";
  }

  outHover(event, url: any) {
    event.target.style.backgroundImage = "url(" + url + ")";
  }

  goto_sales() {
    this.router.navigate(["./software/sale"]);
  }

  goto_cafe() {
    this.router.navigate(["./software/cafe"])
  }

  goto_cam() {
    this.router.navigate(["./software/cloudcam"])
  }
  toggleContact() {
    this.contactSoftStatus.emit({ status: true })
  }

}
